import React, { Fragment } from 'react'
import {
    List,
    Datagrid,
    NumberField,
    TextField,
    BooleanField
} from 'react-admin'

import Title from '../Generic/Title'

export const CategoriaVUList = ({ permissions, ...props }) => {
    if (permissions === null) return null
    return (
        <Fragment>
            <Title title={"Categorias Vida Útil"} />
            <List {...props} sort={{ field: 'id', order: 'ASC' }} exporter={false} >
                <Datagrid rowClick="edit">
                    <NumberField source="id" />
                    <TextField source="name" />
                    <TextField source="description" />
                    <NumberField source="vida_util" />
                    <BooleanField source="active" />
                </Datagrid>
            </List>
        </Fragment>
    )
}

